// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3MYDl","title":"Header_title__a_SHz","side":"Header_side__3p58l"};